module.exports = __webpack_public_path__ + "img/banner-ship-sm.25f67f7d.svg";